import * as types from './mutation-types';
import initState from './state';

export default {
  /**
   * GENERAL
   */
  [types.LOGOUT](state) {
    Object.assign(state, initState());
  },
  [types.SET_TIMEOUT](state, timeout) {
    state.timeout = timeout;
  },
  [types.SET_IS_GENERATING](state, isGenerating) {
    state.isGenerating = isGenerating;
  },
  [types.SET_TIMEOUT_TIME](state, timeoutTime) {
    state.timeoutTime = timeoutTime;
  },
  [types.SET_LINK](state, link) {
    state.link = link;
  },
  [types.SET_KNOWLEDGE_ID](state, knowledgeId) {
    state.knowledgeId = knowledgeId;
  }
  
};
